export type SuggestionsStatus = 'loading' | 'resolved' | 'error' | 'disabled'

export enum SuggestionTypes {
  BestSellers,
  Promotions,
  Releases,
}
